import * as Yup from 'yup';

import { VALIDATION_MESSAGE } from '~/utils/validators';

export const downgradePlanFeedbackSchema = Yup.object({
  other: Yup.string().max(1000, VALIDATION_MESSAGE.MAX_LENGTH),
});

export type DowngradePlanFeedbackDto = Yup.InferType<typeof downgradePlanFeedbackSchema>;
